<template>
  <div class="container-cidades">
    <br>
    <div class="row">
       <h4 class="col-sm-12">Financeiro</h4>


<form class="row" method="POST" ref="formulario" @submit.prevent.stop="add">
          <div class="form-group col-sm-4">
          <label>Valor:</label>
          <input type="text" name="valor" class="form-control" v-money="money" v-model.lazy="valor" />
        </div>

        <div class="form-group col-sm-4">
          <label>IPTU:</label>
          <input type="text" name="iptu" class="form-control" v-money="money" v-model.lazy="iptu"/>
        </div>

        <div class="form-group col-sm-4">
          <label>Condominio:</label>
          <input type="text" name="condominio" class="form-control" v-money="money" v-model.lazy="condominio" />
        </div>

        <div class="form-group col-sm-4">
          <label>Saldo devedor:</label>
          <input type="text" name="saldo" class="form-control" v-money="money" v-model.lazy="saldo" />
        </div>

        <div class="form-group col-sm-4">
          <label>Proposta:</label>
          <select class="form-control" name="proposta" v-model="proposta">
            <option value=""></option>
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
        </div>

         <div class="form-group col-sm-4">
          <label>Permuta:</label>
          <select class="form-control" name="permuta" v-model="permuta">
            <option value=""></option>
            <option value="Não">Não</option>
             <option value="Permuta maior">Permuta maior</option>
             <option value="Permuta menor">Permuta menor</option>
          </select>
        </div>

        <div class="form-group col-sm-4">
          <label>Financiado:</label>
          <select class="form-control" name="financiado" v-model="financiado">
            <option value=""></option>
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
        </div>

        <div class="form-group col-sm-8">
          <label>Observações:</label>
          <textarea  name="observacao" class="form-control" v-model="observacao"></textarea>
        </div>

        

          <button  type="submit" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+ATUALIZAR</button>


          

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
</form>
<br><br>
    </div><!-- row -->


    <div class="row">

      <div v-if="showStatus" class="alert alert-info col-sm-12" role="alert">
       Informações atualizadas com sucesso!
       </div>
    


    </div><!-- row cards -->



  </div>
</template>

<script>
import axios from 'axios'


export default {
  name: 'Financeiro',
  components: {},
  props:['imovel'],
  data(){
      return {
          valor:'',
          iptu:'',
          condominio:'',
          proposta:'',
          permuta:'',
          financiado:'',
          saldo:'',
          observacao:'',
          showStatus:false,
          loading: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false
          }
      }
  },
 

methods:{
    add(){
          this.loading = true;
          let fm = new FormData(this.$refs["formulario"]);
          fm.append('id',this.imovel);
          fm.append('valor',this.filtrar(this.valor));
          fm.append('condominio',this.filtrar(this.condominio));
          fm.append('iptu',this.filtrar(this.iptu));
          fm.append('saldo',this.filtrar(this.saldo));

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/updateValor',fm)
          .then(() => {this.get();this.showStatus = true;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
      },

   
    get(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getImovel',{imovel:this.imovel})
          .then(response => this.updateInfo(response.data))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".");
    },

    
    updateInfo(data){
      this.iptu = data.IM_IPTU;
      this.valor = data.IM_VALOR;
      this.condominio = data.IM_CONDOMINIO;
      this.saldo = data.IM_SALDO;
      this.permuta = data.IM_PERMUTA;
      this.proposta = data.IM_PROPOSTA;
      this.observacao = data.IM_OBSERVACAO_VALOR;
      this.financiado = data.IM_FINANCIADO;
    }

  

},
  
  mounted () {
  this.get();
  }



}
</script>